import { useHistory } from "react-router-dom";

export const useAnnouncementGoBack = () => {
  const history = useHistory();

  return () => {
    history.replace("/announcement/");
  };
};
